export const PAGINATION_DEFAULT = 25;

export const POST_CONTENT_MAX_LENGTH = 1000;
export const POST_COMMENT_MAX_LENGTH = 500;

export const AFFILIATE_PAYOUT_MINIMUM = 10;

export const STOREFRONT_TAGLINE_MAX_LENGTH = 128;
export const STOREFRONT_DESCRIPTION_MAX_LENGTH = 2048;
export const STOREFRONT_COLLECTION_NAME_MAX_LENGTH = 64;
export const STOREFRONT_COLLECTION_DESCRIPTION_MAX_LENGTH = 512;
export const STOREFRONT_COLLECTION_PRODUCTS_MAX = 25;
export const STOREFRONT_COLLECTIONS_MAX = 10;

export const SHOP_URL = 'https://store.playsum.live';

export const AFFILIATE_PARTNER_ROUTES = ['/partner-program', '/storefront'];
